/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

export default {
  today: 'Danes',
  now: 'Zdaj',
  backToToday: 'Nazaj na danes',
  ok: 'V redu',
  clear: 'PoÄisti',
  month: 'Mesec',
  year: 'Leto',
  timeSelect: 'Izberi Äas',
  dateSelect: 'Izberi datum',
  monthSelect: 'Izberi mesec',
  yearSelect: 'Izberi leto',
  decadeSelect: 'Izberi desetletje',
  yearFormat: 'YYYY',
  dateFormat: 'DD.MM.YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Predhodnji mesec (PageUp)',
  nextMonth: 'Naslednji mesec (PageDown)',
  previousYear: 'PrejÅ¡nje leto (Control + left)',
  nextYear: 'Naslednje leto (Control + right)',
  previousDecade: 'PrejÅ¡nje desetletje',
  nextDecade: 'Naslednje desetletje',
  previousCentury: 'PrejÅ¡nje stoletje',
  nextCentury: 'Naslednje stoletje'
};
